<template>
    <select3 :data-url="column.relation.dataUrl" multiple @input="changed" :value="value" :value-key="dataKey"></select3>
</template>
<script>
export default {
    props: ['column'],
    data() {
        return {
            value: null
        };
    },
    methods: {
        changed(selected) {
            this.value = selected;
            let query = {};
            query['m_' + this.column.relation.key] = selected.map(x => x.id);
            // Emit in format 'relation_id[]=1 relation_id[]=4 ...'
            this.$emit('input', query);
        },
    },
    computed: {
        dataKey() {
            if (this.column.relation.translations && this.$lang) {
                return (this.column.relation.dataKey || 'name') + '.' + this.$lang.current;
            }
            return this.column.relation.dataKey;
        },
    },
    watch: {
        column() {
            this.value = null;
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/table/header/ColumnRelation.vue